/* eslint-disable import/prefer-default-export */
import store from '@/store'
import { getData } from '@core/utils/http/general'

const buildParams = (action, extra = {}) => ({
  action,
  token: store.state.cuenta.session.token,
  ...extra,
})

const getAnalytics = async (plan, periodo) => {
  try {
    const response = await getData(buildParams(20, {
      plan,
      periodo,
    }), 'wscompras')
    const { status, data } = response

    // Validamos tanto el status de la red como el del cuerpo de la respuesta
    if (status !== 200 || data.status !== 200) {
      throw new Error(data?.message || 'Error al obtener los datos de getAnalytics')
    }

    return data // Si todo sale bien, retornamos la data
  } catch (error) {
    // Re-lanzamos el error para que getAnalytics lo reciba
    throw error.message || 'Error inesperado en getAnalytics'
  }
}

export {
  getAnalytics,
}
